import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { InsertDriveFile } from '@material-ui/icons';
import GetApp from '@material-ui/icons/GetApp';
import { Button, MdSpace, SmSpace } from 'm2m.components';
import React from 'react';
import { CredenciadosResponse, DocumentsCredenciados } from 'store/modules/credenciados/credenciadosReponse';

export enum DocumentsCredenciadoRequestKind {
  CREDENCIADO = 'CREDENCIADO',
}

interface DocumentsCredenciadoDrawerProps {
  credenciado?: CredenciadosResponse;
  opened: boolean;
  onClose: () => void;
  kind: DocumentsCredenciadoRequestKind;
  disableButtons?: boolean;
}

export const DocumentsCredenciadoDrawer: React.FC<DocumentsCredenciadoDrawerProps> = (props) => {
  const getAttachmentLink = async (doc: DocumentsCredenciados) => {
    try {
      if (doc) {
        const link = document.createElement('a');
        link.href = doc.url;
        link.target = '_blank';
        link.download = doc.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function shortName(name: string, extension: string) {
    if (name.length > 20) return `${name.slice(0, 20)}...${extension}`;

    return `${name}${extension}`;
  }

  return (
    <Drawer
      anchor="right"
      open={props.opened}
      onClose={props.onClose}
      PaperProps={{ style: { padding: '40px', width: 520 } }}
    >
      <Grid container>
        <Grid item sm={12}>
          <SmSpace />
          <Typography variant="h3">{`Comprovantes`}</Typography>
          <Divider variant="fullWidth" />
          <SmSpace />
          {props.credenciado?.documents.map((document, i) => (
            <div key={i}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #C4C4C4',
                  paddingBottom: 40,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', alignContent: 'flex-end', textAlign: 'right' }}>
                  <InsertDriveFile style={{ marginRight: 10 }} fontSize={'small'} />
                  <div style={{ maxWidth: 300, display: 'flex' }}>
                    <Typography
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                      variant="body1"
                    >
                      {shortName(document.fileName, document.extension)}
                    </Typography>
                  </div>
                  <Typography style={{ marginLeft: 10 }}>{`-`}</Typography>
                  <Typography style={{ marginLeft: 10 }}>{`${
                    Math.round((document.size / 1000000) * 100) / 100
                  }MB`}</Typography>
                  <GetApp style={{ marginLeft: 20 }} />
                  <Button onClick={() => getAttachmentLink(document)} variant="text">
                    {'Download'}
                  </Button>
                </div>
              </div>
              <MdSpace />
            </div>
          ))}
          <SmSpace />
          <Button variant="outlined" fullWidth onClick={props.onClose} disabled={props.disableButtons ?? false}>
            {'Fechar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};
